import createIcon from '../../createIcon';

/**
 * @component @name TransitEnterexit
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMThINlY4SDlWMTIuNzdMMTUuOTggNkwxOCA4LjAzTDExLjE1IDE1SDE2VjE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TransitEnterexit = createIcon('TransitEnterexit', [
  ['path', { d: 'M16 18H6V8H9V12.77L15.98 6L18 8.03L11.15 15H16V18Z', key: '1vh87n' }],
]);

export default TransitEnterexit;
